import axiosInstance from '../axios';
import { API_ROUTES } from '../../enums/API_ROUTES';

export const deleteAccess = async (id: string) => {
  const res = await axiosInstance.delete(`${API_ROUTES.ACCESS}/${id}`);
  return res;
};

export const checkContentAvailability = async (type: 'folder' | 'videofeed', id: string | number) => {
  return await axiosInstance.get(`${API_ROUTES.VIDEOFEED_SHARED_CHECK}/${type}/${id}`);
};
